import React from 'react';
import { Typography } from '@mui/material';
import TermsContentEn from '../../../InfoPages/TermsAndConditionsPage/TermsContentEn';
import { getLanguage } from '../../../../i18n';
import TermsContentDe from '../../../InfoPages/TermsAndConditionsPage/TermsContentDe';

export default function StoerkIdPlusTermsAndConditionsText() {
  if (getLanguage() === 'de') {
    return <TermsContentDe />;
  }

  return <TermsContentEn />;
}
